import { activeValue } from "../../../../components/collectionTools";
import { getDiscounts } from "../../../../api/discounts";
export const discountState = (row, now = Date.now()) => {
  if (
    row.finalDate &&
    Number.isFinite(Date.parse(row.finalDate)) &&
    Date.parse(row.finalDate) < now
  )
    return "expired";
  if (!activeValue(row.isActive)) return "inactive";
  if (
    row.initDate &&
    Number.isFinite(Date.parse(row.initDate)) &&
    Date.parse(row.initDate) > now
  )
    return "scheduled";
  return "active";
};

export const discountType = (row) =>
  row.type === "percentage"
    ? "Porcentaje"
    : row.type === "value"
      ? "Importe fijo"
      : row.type || "No disponible";
export const discountValue = (row) =>
  row.discount == null ||
  row.discount === "" ||
  !Number.isFinite(Number(row.discount))
    ? "—"
    : row.type === "percentage"
      ? `${row.discount} %`
      : row.type === "value"
        ? new Intl.NumberFormat("es-ES", {
            style: "currency",
            currency: "EUR",
          }).format(Number(row.discount))
        : "—";
export const discountUses = (row) =>
  `${row.timeUsed ?? "—"} / ${row.useLimit ?? "∞"}`;
const date = (value) =>
  value && Number.isFinite(Date.parse(value))
    ? new Intl.DateTimeFormat("es-ES", { dateStyle: "medium" }).format(
        new Date(value),
      )
    : null;
export const discountPeriod = (row, now = Date.now()) =>
  row.finalDate
    ? date(row.finalDate)
      ? `${discountState(row, now) === "expired" ? "Finalizado" : "Hasta"} ${date(row.finalDate)}`
      : "Fecha no disponible"
    : "Sin caducidad";
export const discountPeriodDetail = (row) =>
  `Desde ${row.initDate ? date(row.initDate) || "fecha no disponible" : "sin límite"} · Hasta ${row.finalDate ? date(row.finalDate) || "fecha no disponible" : "sin límite"}`;
export const getDiscountList = async () => {
  const response = await getDiscounts();
  if (response?.error !== false || !Array.isArray(response.data))
    return { error: true };
  return {
    ...response,
    data: response.data.map((row) => ({
      ...row,
      originalName: row.name,
      name: row.discountCode || "Sin código",
    })),
  };
};
